<template>
 <div>
 </div>
</template>

<script>
// import passwordMeter from "vue-simple-password-meter";
export default {
  
  name: "Resetpassword",
  components: {},
    data: () => ({
    passwordValue: null,
    passwordOld: null,
    pass: '0001',
    score: 2,
    lenpass: false,
     message:       '',
        has_number:    false,
        has_lowercase: false,
        has_uppercase: false,
        has_special:   false,
        passtrue:   false,
        link: '',
        x: false,
  }),
  methods: {
    onScore({ score, strength }) {
      // console.log(score); // from 0 to 4
      // console.log(strength); // one of : 'risky', 'guessable', 'weak', 'safe' , 'secure' 
      this.score = score;
    },
    
    password_check: function () {
       this.lenpass =  this.passwordValue.length > 8
       this.has_number    = /\d/.test(this.passwordValue);
       this.has_lowercase = /[a-z]/.test(this.passwordValue);
       this.has_uppercase = /[A-Z]/.test(this.passwordValue);
                        if(this.passwordValue.length > 8 && this.has_uppercase && this.has_number){
                          this.passtrue = true
                        }
                        else if(this.has_uppercase ){
                          this.passtrue = 3
                        }
                        else if(this.passwordValue.length > 8 ){
                          this.passtrue = 3
                        }
                        else if(this.has_number ){
                          this.passtrue = 3
                        }
                        else{
                          this.passtrue = false
                        }
                }
  }

}
</script>

<style scoped>
.default-input {
  display: flex;
  align-items: flex-end;
  position: relative;
  background-color: #f95e68;
}
.po-password-strength-bar.risky {
    background-color: #f95e68;
  }

  .po-password-strength-bar.guessable {
    background-color: #f95e68;
  }

  .po-password-strength-bar.weak {
    background-color: #f95e68;
  }

  .po-password-strength-bar.safe {
    background-color: #f95e68;
  }

  .po-password-strength-bar.secure {
    background-color: yellow;
  }
  .frmField{
    background-color:white; 
    color:#495057; 
    line-height: 1.25; 
    font-size: 16px; 
    font-family: 'Roboto', sans-serif; 
    border:0; 
    padding: 10px; 
    border:1px solid #dbdbdb;  
    border-radius: 3px; 
    width:90%;
    }

    .frmLabel{
      display: block; 
      margin-bottom: 10px; 
      font-weight: bold;
      }
    .frmValidation{
      font-size: 13px; 
      }
    .frmValidation--passed{
      display: none;
      }
    .frmIcon{
      color:#EB0029;
      }
    .frmValidation--passed .frmIcon{
      color:#0fa140;
      }   

.howToBuild{ 
  text-align:center; 
  color:purple;
  }
.howToBuild a{ 
  color:red; 
  font-weight:bold; 
  text-decoration:none; 
  text-transform:uppercase;
  }
 
</style>